import { Empty } from 'antd';
import React from 'react';

interface IProps {
  /** What is missing, in one line: "No time logged on this job yet". */
  description: React.ReactNode;
  /** What to do about it, if anything can be done here. */
  action?: React.ReactNode;
  /** Roomy enough for a drawer body; compact where it sits inside a panel. */
  size?: 'default' | 'small';
}

/**
 * The one empty state. Everywhere a list can be empty, this says so - rather than an empty table
 * with its headers and scrollbars, which reads as "loading" or "broken" more than "nothing here".
 */
export const SharedEmpty: React.FC<IProps> = ({ description, action, size = 'default' }) => (
  <Empty
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    description={description}
    style={{ padding: size === 'small' ? '12px 0' : '32px 0', margin: 0 }}
  >
    {action}
  </Empty>
);
